export enum EnrollmentFieldOptions {
    None,
    SelfIdentify,
}
